// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"0cbe1af4","119":"372b9000","188":"de9eec2a","292":"fa7a6014","679":"4b0cad6b"}[chunkId] + ".chunk.js";
};